export default __webpack_public_path__ + "static/media/searchImg.70d4c2f2.svg";